const ADD_PURCHASE = "ADD_PURCHASE";
const DELETE_PURCHASE = "DELETE_PURCHASE";
const PURCHASES = "PURCHASES";
const ADD_PURCHASE_ERROR = "ADD_PURCHASE_ERROR";
const PURCHASE_DETAILS = "PURCHASE_DETAILS";

export {
  ADD_PURCHASE,
  DELETE_PURCHASE,
  PURCHASES,
  ADD_PURCHASE_ERROR,
  PURCHASE_DETAILS,
};
